import {  MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';
import { environment } from 'src/environments/environment';
import { PublicClientApplication, InteractionType } from '@azure/msal-browser';

export class Ad {

  public static MSALConfigFactory(): PublicClientApplication {

    const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;
    
    let request = new XMLHttpRequest();
    request.open('GET', "assets/client-config.json", false);  // request application settings synchronous
    request.send(null);
    const response = JSON.parse(request.responseText);

    return new PublicClientApplication({
      auth: {
        clientId: response.azure_client_id,
        authority:  `https://login.microsoftonline.com/${response.azure_tenant_id}`,
        knownAuthorities:['login.microsoftonline.com'],
        redirectUri: Ad.stripQueryStringAndHashFromPath(window.origin),
        postLogoutRedirectUri: Ad.stripQueryStringAndHashFromPath(window.origin),
        navigateToLoginRequestUrl: true,
      },
      cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: isIE,
      }
    } );
  }

  public static stripQueryStringAndHashFromPath(url: string): string {
    return url.split(/[?#]/)[0];
  }

  public static MSALAngularInterceptorConfigFactory(): MsalInterceptorConfiguration{

    const protectedResourceMap = new Map([
      [ "https://graph.microsoft.com/v1.0/me", ['user.read']],
      [ environment.apiUrl, null],
      [ Ad.stripQueryStringAndHashFromPath(window.origin), null],
      [ "assets/client-config.json", null],
      [ "https://angularjs.org/", null]
    ]);

    return {
      interactionType: InteractionType.Redirect,
      protectedResourceMap: protectedResourceMap
    };
  }


  public static MSALAngularGuardConfigFactory(): MsalGuardConfiguration {

    return {
      interactionType: InteractionType.Redirect,
      authRequest: {
        scopes:["openid", "profile", "user.read"]
      }
    }
  }
}
